import { JSX } from 'react';

import CheckIcon from '@videoblocks/react-icons/Check';
import CloseIcon from '@videoblocks/react-icons/Close';

interface FeatureIconProps {
    isAvailable: boolean;
}

export const FeatureIcon = ({ isAvailable }: FeatureIconProps): JSX.Element => {
    if (isAvailable) {
        return <CheckIcon className="w-3 h-3 fill-current text-blue-500" />;
    }

    return <CloseIcon className="w-3 h-3 fill-current text-gray-600" />;
};
